module.exports = __webpack_public_path__ + "img/tongtool.b8f811c3.png";